import React, {useEffect, useContext} from 'react';
import {ViewDataContext} from '../../commons/context/view/ViewDataContext';
import SensitivePackageSearch from "./SensitivePackageSearch";
import {FiltersStateContext} from "../../commons/context/FiltersStateContext";
import {getDocumentURL} from "../../handler/ParentDataHandler";
import { FiltersStateInitializer } from '../../commons/defaultInitializer/FiltersStateInitializer';
 
export const SensitivePackageSearchData = (props) => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');
   
    const {viewModel, dispatch} = useContext(ViewDataContext)

    //Whenever filter value will change, it should re render
    const {selectedFilterValues} = useContext(FiltersStateContext)
    const filters = FiltersStateInitializer(selectedFilterValues);

    if ((selectedFilterValues.isApplyFilterClicked === true || selectedFilterValues.isApplyFilterClicked === undefined)
        //Check for either dwell start and end for Dwell /RTS or ageing tab
           && ((Number(filters.dwellStart) > Number(filters.dwellEnd)) ||  (filters.dwellStartTimeUnit !== filters.dwellEndTimeUnit))) {

        useEffect(() => { 
            getDocumentURL().then(result => {
                dispatch({type: "SET_BASE_URL", data:result});
            });
            dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , 
            stationCode, view : "PACKAGE_DRILLDOWN" ,prevView : viewModel.prevView, leg : selectedFilterValues.leg ? selectedFilterValues.leg.toUpperCase() : "FORWARD", dispatcher: dispatch, isCPTFilter: false}});
        }, [selectedFilterValues]);
 
        useEffect(() => {
            return () => dispatch({ type: 'UNLOAD_VIEW'});
        }, []);
    }

    return (
        <SensitivePackageSearch data = {viewModel.packageResultList} addressFieldsEnabled = {viewModel.addressFieldsEnabled} baseURL = {viewModel.baseURL} isLoading = {viewModel.isLoading} filters = {selectedFilterValues}
        stationCode = {stationCode} dispatcher={dispatch} history={props.history} location={props.location}/>
    )
}


// WEBPACK FOOTER //
// ./src/components/packageList/SensitivePackageSearchData.js